module.exports = __webpack_public_path__ + "media/images/landing/data/epl-b486429582ba09b3e3327d857b88de17.png";